import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IOptionGroupPayload } from '../updateModifierGroup/types';
import { ICreateModifierGroupResponseV2 } from '../../components/CreateOptionGroupModal/types';

export const createModifierGroup = async (
  itemId: string,
  requestBody: IOptionGroupPayload,
  priceSchemeId: string,
): Promise<ICreateModifierGroupResponseV2> => {
  const url = `${API_URL}/items/${itemId}/modifier-groups`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });

  if (!res.ok) {
    throw new Error('Something went wrong whilst creating the modifier group');
  }

  return (await res.json()).data[0];
};
